var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FF8F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.109 21V8.4H15.293C16.409 8.4 17.363 8.58 18.155 8.94C18.959 9.3 19.577 9.816 20.009 10.488C20.441 11.16 20.657 11.958 20.657 12.882C20.657 13.806 20.441 14.604 20.009 15.276C19.577 15.936 18.959 16.446 18.155 16.806C17.363 17.154 16.409 17.328 15.293 17.328H11.405L12.449 16.266V21H10.109ZM18.353 21L15.167 16.428H17.669L20.873 21H18.353ZM12.449 16.518L11.405 15.402H15.185C16.217 15.402 16.991 15.18 17.507 14.736C18.035 14.292 18.299 13.674 18.299 12.882C18.299 12.078 18.035 11.46 17.507 11.028C16.991 10.596 16.217 10.38 15.185 10.38H11.405L12.449 9.228V16.518Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.b1556629eb231f28c531bddff58ef252.svg";
export { ForwardRef as ReactComponent };